import PropTypes from 'prop-types'
import CurrencyInput from 'components/form/CurrencyInput'
import { noop } from 'utils'

const WeightInput = ({
  name,
  max,
  min,
  step,
  maxLength,
  value,
  onChange = noop,
  onValueChange = noop,
  disabled = false,
  error,
}) => {
  const handleDefault = () => {
    onChange({
      target: {
        name,
        value: 100,
        type: 'number',
      },
    })
    onValueChange(100)
  }
  return (
    <CurrencyInput
      name={name}
      max={max}
      min={min}
      step={step}
      maxLength={maxLength}
      value={value}
      onChange={onChange}
      onValueChange={onValueChange}
      disabled={disabled}
      error={error}
      type="%"
      className="box_inptxt inp_weight">
      <button
        type="button"
        className="btn_weight"
        onClick={handleDefault}
        disabled={disabled}>
        기본가중치
      </button>
    </CurrencyInput>
  )
}

WeightInput.propTypes = {
  name: PropTypes.string,
  max: PropTypes.number,
  min: PropTypes.number,
  step: PropTypes.number,
  maxLength: PropTypes.number,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func,
  onValueChange: PropTypes.func,
  disabled: PropTypes.bool,
  error: PropTypes.any,
}

export default WeightInput
